{
  "nav": {
    "mainNavigation": "Main navigation",
    "sectionSettings": "Settings",
    "customers": "Customers",
    "categories": "Categories",
    "settings": "Settings",
    "customerSettings": "Customers settings",
    "users": "Users",
    "groups": "Groups",
    "changeBranch": "Change Branch",
    "systems": "Systems",
    "toggleSidebarHint": "Toggle navigation"
  },
  "brand": "Al-Musafer"
}
